<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Producer"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedProducers"
      :columns="columns"
      :total-rows="totalProducers"
      :get-edit-url="getEditUrl"
    />
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'ProducerTable',
  components: {
    BaseTable
  },
  data() {
    return {
      producers: [],
      totalProducers: 0,
      producerAreas: [], // For producer area dropdown
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'city', align: 'left', label: 'City', field: 'city', sortable: true },
        { name: 'state', align: 'left', label: 'State', field: 'state', sortable: true },
        { name: 'contact_person', align: 'left', label: 'Contact Person', field: 'contact_person', sortable: true },
        { name: 'producer_area_name', align: 'left', label: 'Producer Area', field: 'producer_area_name', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedProducers() {
      return this.producers.map(producer => ({
        ...producer,
        producer_area_name: producer.producer_area_id.name, // Assuming the API returns nested producer area object with `name`
        add_date: new Date(producer.add_date).toLocaleDateString(),
        edit_date: new Date(producer.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchProducers();
    this.fetchProducerAreas();
  },
  methods: {
    fetchProducers() {
      axios
        .get('/api/v1/producer/producers/')
        .then(response => {
          this.producers = response.data;
          this.totalProducers = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching producers:', error);
        });
    },
    fetchProducerAreas() {
      axios
        .get('/api/v1/producer_area/producer-areas/')
        .then(response => {
          this.producerAreas = response.data;
        })
        .catch(error => {
          console.error('Error fetching producer areas:', error);
        });
    },
    onAdd() {
      this.$router.push('/producer/add');
    },
    getEditUrl(row) {
      return `/producer/edit/${row.id}/`;
    }
  },
  watch: {
    producers() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the ProducerTable here */
</style>
